module.exports = __webpack_public_path__ + "img/bg_7.ea1f69ea.png";